/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IDohItem {
  itemImage?: string;
  itemText?: string;
  itemHeading?: string;
}

export interface IDohPage extends IDohItem {
  pageHeading?: string;
  pageText?: string;
  itemList: IDohItem[];
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Castle extends Component {
  private readonly dohPage: IDohPage = {
    pageHeading: 'Play-Doh Brand How To: make a castle',
    pageText:
      'Give ’em the keys to their own mini kingdom with a Play-Doh compound castle that’s simple to make and gives them a whole new playset they can use with all of the other Play-Doh pals they’ve made. This How To uses easy shapes to make a castle with two towers. Enough talkin’ about it, let’s see how it’s done!',

    itemList: [
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1XsK',
        itemText:
          'The castle walls and towers can be built with green Play-Doh compound. Mold a large amount of green Play-Doh compound into a cube shape. Roll some more green Play-Doh compound into a tall cylinder and another into a smaller cylinder. Roll two pieces of blue Play-Doh compound into cone shapes for the spires.',
        itemHeading: 'shape the castle structure',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1XsL',
        itemText:
          'Make some small cubes out of green Play-Doh compound for use as battlements. The Purple Play-Doh compound makes great windows and a door that really stands out, so mold some into a small rectangle for a door and squares for windows. Use pink Play-Doh cans to make flags for spires. Place the two green cylinders on either side of the large cube, and the blue cones on top to make spires.',
        itemHeading: 'doors, battlements and windows',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZZa',
        itemText:
          'Place the purple rectangle in the bottom center of the cube. Place the windows on the towers and the pink flags on top of the spires. The small cubes can be placed at the top of the cube, in front and back, to prepare the castle for any invaders!',
        itemHeading: 'place the pieces',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1UrU',
        itemText:
          'Hear ye, hear ye! Play has arrived! This kingdom is filled with royal fun and they can add a king, queen or loyal subjects to their new castle. Mold some horsies, knights and more to make this Play-Dohcastle come to life!',

        itemHeading: 'play ’til kingdom come!',
      },
    ],
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <h1 className='page-heading'>{this.dohPage.pageHeading}</h1>
          </div>
          <div className='col-md-12'>
            <div className='page-text'>
              <p>{this.dohPage.pageText}</p>
            </div>
          </div>
        </div>
        {this.dohPage.itemList.map((item) => (
          <div className='row'>
            <div className='col-md-12'>
              <table className='box'>
                <tr>
                  <td className='box-1'>
                    <img src={item.itemImage} alt={item.itemHeading} />
                  </td>
                  <td className='box-2'>
                    <h1 className='page-heading'>{item.itemHeading}</h1>
                    <p>{item.itemText}</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        ))}
      </React.Fragment>
    );
  }
}

export default Castle;
